import { useAuthStore } from '@/lib/stores/authStore';

/**
 * Returns true if the current logged-in doctor is an Ayurveda practitioner.
 * Checks practitionerRole.department, practitionerRole.specialty, and specialization fields.
 */
export function useIsAyurveda(): boolean {
  const user = useAuthStore((state) => state.user);
  if (!user) return false;

  const dept = user.practitionerRole?.department?.toLowerCase() ?? '';
  const specialty = user.practitionerRole?.specialty?.toLowerCase() ?? '';
  const specialization = user.specialization?.toLowerCase() ?? '';

  return (
    dept.includes('ayurveda') ||
    specialty.includes('ayurveda') ||
    specialization.includes('ayurveda')
  );
}
